import React from 'react';

import { flagStyles } from '../settings';

const SvgCW = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1224px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgCW;
